<template>
  <div class="home">
    <h3>Выберите команду в меню. Типы встреч, ведущие и ротация настраиваются внутри команды.</h3>
  </div>
</template>

<script>
import grpc from "@/services/grpc";

export default {
  name: 'MainPageComponent',
  data() {
    return {
      grpcClient: new grpc(),
    };
  },
}
</script>